import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

//对账单列表
export const findBillList = (params) => {
    params = parseParam(params);
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/check/list?`+params,
        method: 'GET',
    })
};

//通过手机号查询店铺信息
export const findMobileShop = (mobile) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop/mobile/`+mobile,
        method: 'GET'
    })
};
//通过ID查询客户账户总余额
export const findUserBalance = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountBalance/findAccountBalanceById?${id}`,
        method: 'GET'
    })
};
//通过ID查询店铺信息及余额
export const findShop = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/check/findCheckByShopId/${id}`,
        method: 'GET'
    })
};

//新增查询部门
export const findDepartment= () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/choose`,
        method: 'GET'
    })
};
//根据部门查询员工
export const findStaff= (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/choose?departId=${id}`,
        method: 'GET'
    })
};
//新增对账单
export const addBill = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/check/insertCheck`,
        method: 'POST',
        data: data
    })
};
//对账单详情查看
export const lookBillDetails= (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/check/findCheck/${id}`,
        method: 'GET'
    })
};
//对账单编辑
export const billEdit = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/check/updateCheck`,
        method: 'PUT',
        data: data
    })
};
//新增对账单
export const addDrafts = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/check/saveCheck`,
        method: 'POST',
        data: data
    })
};